import Search from './components/Search.vue'

const router = {
  name: 'search',
  path: '/search',
  component: Search,
  meta: {
    showMenu: false,
    requiresAuth: true,
    requiresPermission: true,
    action: 53,
    titleHeader: 'Buscador de empleados'
  }
}

export default router
